import * as fromState from './public.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const getPublicState = createFeatureSelector<fromState.PublicState>('public');

export const getPrivateLabelLogo = createSelector(getPublicState, fromState.getPrivateLabelLogo);
